module.exports = __webpack_public_path__ + "static/media/logo-ciaautismo-print.eb098a78.png";